<template>
  <div style="padding: 1rem 1.5rem;">
    <div slot="top-right">
      <button @click="$modal.hideAll()">
        ❌
      </button>
    </div>
    <h1>This is created inline</h1>
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "ModalTemplate",
  props: {
    text: String
  }
};
</script>
